import React from 'react';
import styled from 'styled-components';
import { DropdownContext, IDropdownBaseProps } from '../Dropdown/DropdownContext';
import { IColoursCollection } from '../../fundamentals/colours/colourInterfaces';
import { BaseDiv } from '../../common/BaseElements';

export const menuColours = ({ base }: IColoursCollection) => ({
  menuColours: {
    background: base.white.colour
  }
});

export interface IMenuProps extends React.PropsWithChildren, Pick<IDropdownBaseProps, 'debounceInMs'> {
  compact?: boolean;
}

const Collapsible = styled(BaseDiv)<Pick<IMenuProps, 'compact'>>`
  width: ${({ theme, compact }) => theme.spaces[compact ? '80' : '256']};
  background: ${({ theme }) => theme.menuColours.background};
`;

export const Menu: React.FC<IMenuProps> = ({ children, debounceInMs = 0, ...rest }) => {
  const [expandedSectionId, setExpandedSectionId] = React.useState<string | undefined>();
  return (
    <DropdownContext.Provider value={{ debounceInMs, asMenu: false, expandedSectionId, setExpandedSectionId }}>
      <Collapsible {...rest}>{children}</Collapsible>
    </DropdownContext.Provider>
  );
};
